module.exports = __webpack_public_path__ + "media/workplace/rating-excellent-c16ec33b.svg";